import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLenis } from "lenis/react";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { MarqueeStrip } from "../components/MarqueeStrip";
import { Services } from "../components/Services";
import { Process } from "../components/Process";
import { About } from "../components/About";
import { MediaMention } from "../components/MediaMention";
import { InstagramSection } from "../components/InstagramSection";
import { Faq } from "../components/Faq";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";

export default function HomePage() {
  const location = useLocation();
  const lenis = useLenis();

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target) {
      const t = setTimeout(() => lenis?.scrollTo(`#${target}`, { offset: -96, duration: 1.4 }), 350);
      return () => clearTimeout(t);
    }
  }, [location.state, lenis]);

  return (
    <div data-testid="home-page">
      <a
        href="#palvelut"
        className="sr-only focus:not-sr-only focus:absolute focus:top-3 focus:left-3 focus:z-[60] focus:bg-[#2B2724] focus:text-[#FBF8F4] focus:px-5 focus:py-3 focus:rounded-full"
        data-testid="skip-link"
      >
        Siirry sisältöön
      </a>
      <Navbar />
      <main>
        <Hero />
        <MarqueeStrip />
        <Services />
        <Process />
        <About />
        <MediaMention />
        <InstagramSection />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
